import type { UploadFile } from '@timeedit/ui-components/antd';

export const stillSelectedDetail = (fileList: UploadFile[]) =>
  fileList.length > 0
    ? [`"${fileList[0].name}" is still selected.`]
    : undefined;
